import React from "react";
import { Link } from "react-router-dom";
import Logo from "../marketing/Logo";
import { ShieldCheck, Lock, FileCheck } from "lucide-react";

/**
 * Centered card layout used by Login, 2FA, Forgot Password, etc.
 * For SignUp we use a two-column layout (different component).
 */
export default function AuthLayout({ title, subtitle, children, footer, testid }) {
  return (
    <div className="min-h-screen bg-navy-900 flex flex-col" data-testid={testid || "auth-layout"}>
      <div className="px-6 lg:px-10 pt-8">
        <Link to="/"><Logo variant="light" /></Link>
      </div>

      <div className="flex-1 flex items-center justify-center px-6 py-10">
        <div className="w-full max-w-md">
          <div className="card2 p-8 shadow-card-hover animate-slide-up">
            <h1 className="t-h1 mb-2">{title}</h1>
            {subtitle && <p className="t-body text-slate2 mb-6">{subtitle}</p>}
            {children}
          </div>
          {footer && (
            <div className="mt-5 text-center t-body-sm text-white/60">{footer}</div>
          )}
          <div className="mt-8 flex items-center justify-center gap-5 text-xs text-white/40">
            <span className="inline-flex items-center gap-1.5"><Lock size={11} className="text-emerald2" /> Bank-grade encryption</span>
            <span className="inline-flex items-center gap-1.5"><ShieldCheck size={11} className="text-emerald2" /> FCA-aware</span>
            <span className="inline-flex items-center gap-1.5"><FileCheck size={11} className="text-emerald2" /> GDPR-compliant</span>
          </div>
        </div>
      </div>
    </div>
  );
}
